export default __webpack_public_path__ + "static/media/gabung.91d9de07.png";